import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {StaticDataService} from "../../../services/static-data.service";
import {EnumValidValueItemModel} from "../../../models/enum/enum-valid-value-item.model";
import {InsuranceService} from "../insurance.service";
import {DxListComponent} from "devextreme-angular";

@Component({
    selector: 'app-insurance-dx-cross-ref',
    templateUrl: './insurance-dx-cross-ref.component.html',
    styleUrls: ['./insurance-dx-cross-ref.component.scss']
})
export class InsuranceDxCrossRefComponent implements OnInit {
  @ViewChild(DxListComponent, { static: false }) list: DxListComponent;

    mode: string;
    listHeight: number = 400;
    //enumInsuranceRelations:   EnumValidValueItemModel[] = [];
    topics: string ="";
    claimParatmeters: any[] = [];
    selectedParam: any;
    selectedDXItemKeys: any[] = [];


    constructor(
        private staticDataService: StaticDataService,
        private insuranceService: InsuranceService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialog: MatDialogRef<InsuranceDxCrossRefComponent>
    ) {
    }

    relationEnumsPerDX = [
    {IDvalue: '01', description: 'Spouse', selected: false},
    {IDvalue: '18', description: 'Self', selected: false},
    {IDvalue: '19', description: 'Child', selected: false},
    {IDvalue: '20', description: 'Employee', selected: false},
    {IDvalue: '21', description: 'Unknown', selected: false},
    {IDvalue: '22', description: 'Handicapped Dependent', selected: false},
    {IDvalue: '29', description: 'Significant Other', selected: false},
    {IDvalue: '34', description: 'Other Adult', selected: false},
    {IDvalue: '41', description: 'Injured Plaintiff', selected: false},
    {IDvalue: '53', description: 'Life Partner', selected: false},
    {IDvalue: '76', description: 'Dependent', selected: false},
    {IDvalue: '99', description: 'Other', selected: false},
  ];



    ngOnInit(): void {

        this.mode = this.data.mode;  // eg: 'Relationship'

        // load data: enumInsuranceRelation




      if(this.mode === 'Relationship') {
        this.topics = 'enumInsuranceRelation';
      }

      this.insuranceService.getClaimProcessorParamas("00000223-1000-0000-0000-000000000001", this.topics).subscribe((result) => {

        this.claimParatmeters = result;


        //this.enumInsuranceRelations = this.staticDataService.getValidValueItemsByValidValueName('enumInsuranceRelation');


      })





    }

  onSave() : void {
      this.insuranceService.saveClaimProcessorParams(this.claimParatmeters).subscribe((result) => {



        this.dialog.close("OK");
      })






  }
  onCancel() : void {
    this.dialog.close("X");

  }


  myRelationshipSelectionChanged(e: any) {

      this.selectedParam = e.addedItems[0];

      if(this.selectedParam.Value1) {

        this.selectedDXItemKeys=[];
        this.selectedDXItemKeys.push(this.selectedParam.Value1 );

        //this.selectItem(this.selectedParam.Value1);

      }
      else {

        //this.selectItem("");

      }


  }

  selectItem(key: any) {
    this.list.instance.option('selectedItemKeys', [key]);
  }

  DXRelationshipSelectionChanged(e: any) {

    this.selectedParam.Value1 =  e.addedItems[0].IDvalue;

    // console.log('sel keys',this.selectedDXItemKeys);
    // this.selectedDXItemKeys = [];
    // this.selectedDXItemKeys.push(e.addedItems[0].IDvalue);
    //
    // console.log(this.selectedDXItemKeys);


  }
}
